import { useCurrencyFormatterConnected } from '../../../../hooks/useCurrencyFormatterConnected';
import { useConfigSlice } from '../../../../store/slices/config/selectors';

export const useTotalBetWalletPlaceholder = (): string | undefined => {
  const tableBetLimits = useConfigSlice.tableBetLimits();
  const currencyFormatter = useCurrencyFormatterConnected();

  // This complex expression is to ensure that placeholder has a proper width
  // If table has a max bet, we use formatted max bet as a placeholder
  // If not - we explicitly set it to be undefined, so StickyWidthValue component will use rendered value
  return tableBetLimits && tableBetLimits?.max !== null
    ? (currencyFormatter(tableBetLimits.max) ?? undefined)
    : undefined;
};
